import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const activityTypeDictionary = createSimpleDictionary([
    { id: 'bets_done', name: 'bets.activityType.betsDone' },
    { id: 'bets_failed', name: 'bets.activityType.betsFailed' },
]);
